import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import CheckboxField from '@/shared/components/form/CheckBox';
import { Row, Col, ButtonToolbar, Button, FormGroup } from 'reactstrap';
import formValidation from "@/shared/validation/merchants/addMerchant";
import renderSelectField from '@/shared/components/form/Select';
import axios from 'axios';
import {mapFormDataUploads, patchMerchantMediaURL, unpatchMerchantFields} from '@/shared/helpers'
import renderDropZoneField from '@/shared/components/form/DropZone';
import {useDispatch, sendFlashMessage} from "@/shared/components/flash"
import WYSIWYGEditor from '@/shared/components/form/WYSIWYGEditor'
import { useParams } from 'react-router-dom'
import {labelizeNamedData, labelizeNamedRow} from '@/shared/helpers'
import getCountries from "@/service/getCountries";
import getRewardPlatform from "@/service/getRewardPlatform";
import getCategories from "@/service/getCategories";
import arrayMutators from 'final-form-arrays';
import { FieldArray } from 'react-final-form-arrays';

const fetchMerchant = async ( id ) => {
    try {
        const response = await axios.get(`/merchant/${id}`);
        return response.data;
    } catch (e) {
        throw new Error(`API error:${e?.message}`);
    }
};

const EditMerchantForm = ({ organization }) => {

    const dispatch = useDispatch()
    let { id } = useParams();

    const [loading, setLoading] = useState(false)
    const [toaOptions, setToaOptions] = useState(false)
    const [useVirtualInventory, setUseVirtualInventory] = useState(false)
    const [useCronjob, setUsecronjob] = useState(false)
    const [errors, setErrors] = useState(null)
    const [countries, setCountries] = React.useState([])
    const [rewardPlatforms, setRewardPlatforms] = React.useState([])
    const [rewardPlatform, setRewardPlatform] = React.useState(0)
    const [categories, setCategories] = React.useState([])

    let [merchant, setMerchant] = useState(null)
    //initialValues={patchMerchantMediaWithURL(merchant, ['logo', 'icon', 'large_icon', 'banner'])}

    const loadTangoApiConfigurations = async (reward_platform_id) => {
        try {
          const response = await axios.get(`/tango-api/index?reward_platform_id=${reward_platform_id}`);
          if (response.data.length === 0) return [];
          let options = [];
          response.data.map(row => {
            options.push({
              value: row.id,
              label: row.name
            });
          });
          return options;
        } catch (e) {
          throw new Error(`API error:${e?.message}`);
        }
      }

    useEffect( ()=>{
        setLoading(true)
        fetchMerchant( id )
        .then( response => {
            let merchantData = response;
            if(rewardPlatform) {
                merchantData.reward_platform_id = rewardPlatform;
            }
            loadTangoApiConfigurations(merchantData.reward_platform_id).then( res => {
                setToaOptions(res);
                setMerchant(merchantData);
                setUseVirtualInventory(merchantData.use_virtual_inventory);
                setUsecronjob(merchantData.use_cronjob);
                setLoading(false)
            })
        })
    }, [id, rewardPlatform])

    useEffect(() => {
        if (countries.length === 0) {
            getCountries()
              .then(result => {
                  setCountries(labelizeNamedData(result))
              })
        }
    },)

    useEffect(() => {
        if (rewardPlatforms.length === 0) {
            getRewardPlatform()
              .then(result => {
                  setRewardPlatforms(labelizeNamedData(result))
              })
        }
    },)

    useEffect(() => {
        if (categories.length === 0 && organization?.id) {
            getCategories(organization.id)
              .then(result => {
                  setCategories(labelizeNamedData(result, ['name', 'name']))
              })
        }
    }, [organization?.id])

    const onChangePlatform = (value) => {
        let val = value?.value;
        let merchantValues = merchant;
        merchantValues.reward_platform_id = val;
        setMerchant(merchantValues);
        setRewardPlatform(val)
    }

    const onChangeUseVirtualInventory = () => {
        setUseVirtualInventory( !useVirtualInventory )
    }

    const onChangeUseCronjob = () => {
        setUsecronjob( !useCronjob )
    }

    const onSubmit = values => {
        values = unpatchMerchantFields(values)

        // values = unpatchMerchantMediaURL(values)
        // alert(JSON.stringify(values))
        // return;
        values.physical_card_option = values.physical_card_option ? 1 : 0;
        // `category` is a plain name string when untouched (still the raw value from
        // initialValues={merchant}) or an `{value,label}` react-select option once touched;
        // null when explicitly cleared (and dropped entirely by unpatchMerchantFields above).
        values.category = typeof values.category === 'object' ? (values.category?.value ?? '') : (values.category ?? '');
        let formData = mapFormDataUploads( values )
        // 4. FIX: Manually build multi-part array indices for shipping tiers
        if (values.physical_card_option && values.shipping_fees && Array.isArray(values.shipping_fees)) {
            // Remove the broken native serialization string if it was appended
            formData.delete('shipping_fees');

            // Map each row property to a specific index token key
            values.shipping_fees.forEach((fee, index) => {
                formData.append(`shipping_fees[${index}][min_qty]`, fee.min_qty ?? '');
                formData.append(`shipping_fees[${index}][max_qty]`, fee.max_qty ?? '');
                formData.append(`shipping_fees[${index}][fee]`, fee.fee ?? '');
            });
        } else {
            formData.delete('shipping_fees');
        }
        // return
        formData.append('_method', 'PUT')
        axios.post(`/merchant/${merchant.id}`, formData, {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*"
        })
        .then( (res) => { 
            // console.log(res)
            if(res.status == 200)  {
                window.location = `/merchants/view/${merchant.id}?message=Merchant updated successfully!`
            }
        })
        .catch( error => {
            console.log(JSON.stringify(error));
            // setErrors(error.response.data.errors);
            // dispatch(sendFlashMessage(JSON.stringify(error.response.data.errors), 'alert-danger'))
            // throw new Error(`API error:${e?.message}`);
            setLoading(false)
        })
    }
    
    const onClickCancel = () => {
        window.location = `/merchants`
    }

    if( loading || !merchant ) return <p>Loading...</p>

    // patchMerchantMediaWithURL()

    // console.log(merchant)

    merchant = patchMerchantMediaURL( merchant )

    return (
    <Form
        onSubmit={onSubmit}
        mutators={{ ...arrayMutators }}
        validate={(values) => formValidation.validateForm(values)}
        initialValues={merchant}
    >
    {({ handleSubmit, form, submitting, pristine, values }) => (
    <form className="form" onSubmit={handleSubmit}>
        {errors && 
            <div className="alert alert-danger fade show w100 mb-4" role="alert">
                <div className="alert__content">{errors}</div>
            </div>
        }
        <Row className='w100'>
            <Col md="6" lg="6" xl="6">
                <h3 className="mb-4">Edit Merchant</h3>
            </Col>
            <Col md="6" lg="6" xl="6" className='text-right'>
                <ButtonToolbar className="modal__footer flex justify-content-right w100">
                    <Button outline color="primary" className="mr-3" onClick={onClickCancel}>Cancel</Button>{' '}
                    <Button type="submit" disabled={loading || pristine} className="btn btn-primary" color="#ffffff">Save</Button>
                </ButtonToolbar>
            </Col>
        </Row>
        <Row>
            <Col md="4" lg="4" xl="4">
                <Field name="name">
                {({ input, meta }) => (
                    <div className="form__form-group">
                        <span className="form__form-group-label">Merchant Name</span>
                        <div className="form__form-group-field">
                            <div className="form__form-group-row">
                                <input type="text" {...input} placeholder="Merchant Name" />
                                {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                            </div>
                        </div>
                    </div>
                )}
                </Field>
            </Col>
            <Col md="4" lg="4" xl="4">
                <Field name="merchant_code">
                {({ input, meta }) => (
                    <div className="form__form-group">
                        <span className="form__form-group-label">Merchant Code</span>
                        <div className="form__form-group-field">
                            <div className="form__form-group-row">
                                <input type="text" {...input} placeholder="Merchant Code" />
                                {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                            </div>
                        </div>
                    </div>
                )}
                </Field>
            </Col>
            <Col md="4" lg="4" xl="4">
                <div className="form__form-group">
                    <Field
                        name="is_pfi_merchant"
                        type="checkbox"
                        component={CheckboxField}
                        label="PFI Merchant"
                    />
                </div>
            </Col>
        </Row>
        <Row>
            <Col md="3" lg="3" xl="3">
                <div className="form__form-group">
                    <Field
                        name="is_default"
                        type="checkbox"
                        component={CheckboxField}
                        label="Default"
                    />
                </div>
                <div className="form__form-group">
                    <Field 
                        name="is_premium"
                        label="Premium"
                        type="checkbox"
                        component={CheckboxField}
                    />
                </div>
            </Col>
            <Col md="3" lg="3" xl="3">
                <div className="form__form-group">
                    <Field 
                    name="physical_order"
                    label="Physical Order"
                    type="checkbox"
                    component={CheckboxField}
                />
                </div>
                <div className="form__form-group">
                    <Field 
                        name="requires_shipping"
                        label="Requires Shipping"
                        type="checkbox"
                        component={CheckboxField}
                    />
                </div>
            </Col>
            <Col md="3" lg="3" xl="3">
                <div className="form__form-group">
                    <Field 
                        name="giftcodes_require_pin"
                        label="Gift Codes Require PIN"
                        type="checkbox"
                        component={CheckboxField}
                    />
                </div>
                <div className="form__form-group">
                    <Field 
                    name="display_popup"
                    label="Display Popup"
                    type="checkbox"
                    component={CheckboxField}
                />
                </div>
            </Col>
        </Row>
        <Row>
            <Col md="3" lg="3" xl="3">
                <div className="form__form-group">
                    <Field
                        name="get_gift_codes_from_root"
                        type="checkbox"
                        component={CheckboxField}
                        label="Get Gift Codes from root"
                    />
                </div>
            </Col>
            <Col md="3" lg="3" xl="3">
                <div className="form__form-group">
                    <Field 
                        name="is_recommended"
                        label="Recommended"
                        type="checkbox"
                        component={CheckboxField}
                    />
                </div>
            </Col>
            <Col md="3" lg="3" xl="3">
                <div className="form__form-group">
                    <Field name="physical_card_option" type="checkbox">
                        {({ input }) => (
                            <CheckboxField 
                                {...input}
                                label="Physical Card option" 
                            />
                        )}
                    </Field>
                </div>
            </Col>
        </Row>
        {/* DYNAMIC VISA OPTIONS REPEATER BLOCK */}
        {values.physical_card_option && (
            <div className="p-3 mb-4 rounded border w-75"  style={{ backgroundColor: 'rgb(254 254 254)' }}>
                <h4 className="mb-3 thick size16" style={{ color: '#4B5563' }}>Visa Configuration Metrics</h4>
                <Row>
                    <Col md="4">
                        <Field name="fulfillment_fee_per_card">
                            {({ input, meta }) => (
                                <div className="form__form-group">
                                    <span className="form__form-group-label">Fulfillment Fee Per Card ($)</span>
                                    <div className="form__form-group-field">
                                        <input type="number" step="0.01" {...input} placeholder="0.50" />
                                        {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                    </div>
                                </div>
                            )}
                        </Field>
                    </Col>
                    <Col md="4">
                        <Field name="visa_premium_fee">
                            {({ input, meta }) => (
                                <div className="form__form-group">
                                    <span className="form__form-group-label">Visa Premium fee(%)</span>
                                    <div className="form__form-group-field">
                                        <input type="number" min="0" max="100" step="0.01" {...input} placeholder="4" />
                                        {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                    </div>
                                </div>
                            )}
                        </Field>
                    </Col>
                </Row>

                <h5 className="mt-3 mb-2 size14 font-weight-bold">Custom Shipping Tiers</h5>
                <FieldArray name="shipping_fees">
                    {({ fields }) => (
                        <div>
                            {fields.map((name, index) => (
                                <Row key={name} className="align-items-center mt-0 mb-2">
                                    <Col md="3">
                                        <FormGroup className="mb-0">
                                            <span className="text-muted small">Min Qty</span>
                                            <Field name={`${name}.min_qty`}>
                                                {({ input }) => <input type="number" className="form-control" placeholder="0" {...input} />}
                                            </Field>
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup className="mb-0">
                                            <span className="text-muted small">Max Qty</span>
                                            <Field name={`${name}.max_qty`}>
                                                {({ input }) => <input type="number" className="form-control" placeholder="30" {...input} />}
                                            </Field>
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup className="mb-0">
                                            <span className="text-muted small">Fee Amount</span>
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                     <span className="input-group-text small" 
                                                        style={{ 
                                                            fontSize: '12px',
                                                            backgroundColor: '#f6f6f6',
                                                            borderColor: '#f0f1f3'
                                                         }}>
                                                        $
                                                    </span>
                                                </div>
                                                <Field name={`${name}.fee`}>
                                                    {({ input }) => <input type="number" step="0.01" className="form-control" placeholder="0.00" {...input} />}
                                                </Field>
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col md="3" className="pt-3">
                                        <Button type="button" color="danger" outline size="sm" onClick={() => fields.remove(index)}>
                                            Remove
                                        </Button>
                                    </Col>
                                </Row>
                            ))}
                            <Button type="button" color="success" size="sm" className="mt-2" onClick={() => fields.push({ min_qty: '', max_qty: '', fee: '' })}>
                                + Add New
                            </Button>
                        </div>
                    )}
                </FieldArray>
            </div>
        )}
        <Row>
            <Col md="6" lg="4" xl="4">
                <Field name="countries">
                    {({ input, meta }) => (
                      <div className="form__form-group">
                          <span className="form__form-group-label">Country</span>
                          <div className="form__form-group-field">
                              <div className="form__form-group-row">
                                  <Field
                                    name="country_id"
                                    component={renderSelectField}
                                    options={countries}
                                  />
                                  {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                              </div>
                          </div>
                      </div>
                    )}
                </Field>
            </Col>
        </Row>
        <Row>
            <Col md="6" lg="4" xl="4">
                <Field name="reward_platform_id">
                    {({ input, meta }) => (
                      <div className="form__form-group">
                          <span className="form__form-group-label">Reward Platform</span>
                          <div className="form__form-group-field">
                              <div className="form__form-group-row">
                                  <Field
                                    name="reward_platform_id"
                                    component={renderSelectField}
                                    options={rewardPlatforms}
                                    parse={value => {
                                        onChangePlatform(value)
                                        return value;
                                    }}
                                  />
                                  {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                              </div>
                          </div>
                      </div>
                    )}
                </Field>
            </Col>
            <Col md="6" lg="4" xl="4">
              <div>
                  <div className="form__form-group">
                      <span className="form__form-group-label">Reward Platform Configurations</span>
                      <div className="form__form-group-field">
                          <Field
                            name="toa_id"
                            component={renderSelectField}
                            options={toaOptions}
                          />
                      </div>
                  </div>
                  <div className="form__form-group">
                      <Field
                        name="set_second_email_from_tango"
                        type="checkbox"
                        component={CheckboxField}
                        label="Send the second email from Reward Platform"
                      />
                  </div>
              </div>
            </Col>
        </Row>
        <Row>
            <Col md="6" lg="4" xl="4">
                <div className="form__form-group">
                    <span className="form__form-group-label">Category</span>
                    <div className="form__form-group-field">
                        <div className="form__form-group-row">
                            <Field
                              name="category"
                              component={renderSelectField}
                              options={categories}
                              isClearable
                              placeholder="Select category"
                            />
                        </div>
                    </div>
                </div>
            </Col>
        </Row>
        <Row>
            <Col md="6" lg="6" xl="6">
                 <div className="form__form-group">
                        <Field
                            name="use_virtual_inventory"
                            label="Use Virtual Inventory"
                            type="checkbox"
                            component={CheckboxField}
                            parse={ value => {
                                onChangeUseVirtualInventory()
                                return value
                            }}
                        />
                    </div>
            </Col>
        </Row>
        <Row>
            <Col md="6" lg="6" xl="6">
                {useVirtualInventory ? (
                    <Row>
                        <Col md="6" lg="6" xl="6">
                            <Field name="virtual_denominations">
                                {({input, meta}) => (
                                    <div className="form__form-group">
                                        <span className="form__form-group-label">Virtual Denominations</span>
                                        <div className="form__form-group-field">
                                            <div className="form__form-group-row">
                                                <input  type="text" {...input} placeholder=""/>
                                                {meta.touched && meta.error &&
                                                <span className="form__form-group-error">{meta.error}</span>}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </Field>
                        </Col>
                        <Col md="6" lg="6" xl="6">
                            <Field name="virtual_discount">
                                {({input, meta}) => (
                                    <div className="form__form-group">
                                        <span className="form__form-group-label">Virtual Discount</span>
                                        <div className="form__form-group-field">
                                            <div className="form__form-group-row">
                                                <input  type="text" {...input} placeholder=""/>
                                                {meta.touched && meta.error &&
                                                <span className="form__form-group-error">{meta.error}</span>}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </Field>
                        </Col>
                    </Row>
                ) : '' }
            </Col>
        </Row>
        <Row>
            <Col md="6" lg="6" xl="6">
                <div className="form__form-group">
                    <Field
                      name="use_cronjob"
                      label="Use Cronjob to generate Test Codes"
                      type="checkbox"
                      component={CheckboxField}
                      parse={ value => {
                          onChangeUseCronjob()
                          return value
                      }}
                    />
                </div>
            </Col>
        </Row>
        <Row>
            <Col md="6" lg="6" xl="6">
                {useCronjob ? (
                  <Row>
                      <Col md="6" lg="6" xl="6">
                          <Field name="test_denominations">
                              {({input, meta}) => (
                                <div className="form__form-group">
                                    <span className="form__form-group-label">Test Denominations</span>
                                    <div className="form__form-group-field">
                                        <div className="form__form-group-row">
                                            <input  type="text" {...input} placeholder=""/>
                                            {meta.touched && meta.error &&
                                              <span className="form__form-group-error">{meta.error}</span>}
                                        </div>
                                    </div>
                                </div>
                              )}
                          </Field>
                      </Col>
                      <Col md="6" lg="6" xl="6">
                          <Field name="test_discount">
                              {({input, meta}) => (
                                <div className="form__form-group">
                                    <span className="form__form-group-label">Test Discount</span>
                                    <div className="form__form-group-field">
                                        <div className="form__form-group-row">
                                            <input  type="text" {...input} placeholder=""/>
                                            {meta.touched && meta.error &&
                                              <span className="form__form-group-error">{meta.error}</span>}
                                        </div>
                                    </div>
                                </div>
                              )}
                          </Field>
                      </Col>
                  </Row>
                ) : '' }
            </Col>
        </Row>
        <Row>
            <Col md="6" lg="6" xl="6">
                <Field name="website">
                {({ input, meta }) => (
                    <div className="form__form-group">
                        <span className="form__form-group-label">Website</span>
                        <div className="form__form-group-field">
                            <div className="form__form-group-row">
                                <input type="text" {...input} placeholder="Website" />
                                {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                            </div>
                        </div>
                    </div>
                )}
                </Field>  
            </Col>
        </Row>        
        <Row className='mb-3'>
            <Col md="8" lg="8" xl="8">
                <Field
                    name="description"
                    component={WYSIWYGEditor}
                />
            </Col>
        </Row>
        <Row className='mb-3'>
            <Col md="8" lg="8" xl="8">
                <Field
                    name="redemption_instruction"
                    component={WYSIWYGEditor}
                />
            </Col>
        </Row>
        <Row>
            <Col md="8" lg="8" xl="8">
                <div className="form__form-group">
                    <span className="form__form-group-label">Logo</span>
                    <div className="form__form-group-field  flex-column">
                        <Field
                        name="logo"
                        component={renderDropZoneField}
                        multiple={false}
                        customHeight
                        />
                        <RenderImage src={merchant.logo} />
                    </div>
                </div>
                <div className="form__form-group">
                    <span className="form__form-group-label">Icon</span>
                    <div className="form__form-group-field flex-column">
                        <Field
                        name="icon"
                        component={renderDropZoneField}
                        multiple={false}
                        customHeight
                        />
                        <RenderImage src={merchant.icon} />
                    </div>
                </div>
                <div className="form__form-group">
                    <span className="form__form-group-label">Large Icon</span>
                    <div className="form__form-group-field flex-column">
                        <Field
                            name="large_icon"
                            component={renderDropZoneField}
                            multiple={false}
                            customHeight
                        />
                        <RenderImage src={merchant.large_icon} />
                    </div>
                </div>
                <div className="form__form-group">
                    <span className="form__form-group-label">Banner</span>
                    <div className="form__form-group-field flex-column">
                        <Field
                            name="banner"
                            component={renderDropZoneField}
                            multiple={false}
                        />
                        <RenderImage src={merchant.banner} />
                    </div>
                </div>
            </Col>
        </Row>
    </form>
    )}
  </Form>
)}

const RenderImage = ({src}) => {
    if( !src || typeof src === 'undefined' ) return ''
    return (
        <div className='dropzone-img'>
            <img src={src} />
        </div>
    )
}
export default connect(state => ({
    organization: state.organization
}))(EditMerchantForm);
